<template>
  <div class="mt-2">
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Tax - New Tax Roll - Import & Balance' }"
        id="taxRollImportNBalance"
        class="input-text-size"
      >
      Import & Balance
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - New Tax Roll - Assessor X-Ref' }"
        id="taxRollAssessorXRef"
        class="input-text-size"
      >
      Assessor X-Ref
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - New Tax Roll - Merge & Finalize' }"
        id="taxRollMergeNFinalize"
        class="input-text-size"
      >
      Merge & Finalize
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - New Tax Roll - Fire Tax X-Ref' }"
        id="taxRollFireTaxXRef"
        class="input-text-size"
      >
      Fire Tax X-Ref
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../../../../assets/style.css';

export default {
  name: 'NewTaxRoll',
  components: {
  },
};
</script>
